import * as React from 'react';

const DiamondIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.97966 16.2449C9.52048 16.2449 9.09191 16.051 8.77558 15.7143L2.71436 9.14285C2.15313 8.53061 2.13272 7.59183 2.68374 6.95918L4.97966 4.31632C5.28578 3.95918 5.73476 3.7551 6.21436 3.7551H13.7756C14.245 3.7551 14.6939 3.95918 15.0001 4.31632L17.3062 6.95918C17.8572 7.59183 17.847 8.53061 17.2756 9.14285L11.1735 15.7143C10.8674 16.051 10.4286 16.2449 9.97966 16.2449Z"
      fill="url(#paint0_linear_1094_19625)"
    />
    <path
      d="M9.89785 12.551C9.79581 12.551 9.68356 12.5102 9.60193 12.4286L5.62234 8.34695C5.46928 8.18368 5.46928 7.92858 5.63254 7.76532C5.79581 7.61225 6.05091 7.61225 6.21418 7.77552L9.90805 11.5612L13.7958 7.76532C13.9591 7.61225 14.2142 7.61225 14.3774 7.77552C14.5305 7.93878 14.5305 8.19389 14.3672 8.35715L10.1836 12.4388C10.1019 12.5102 9.99989 12.551 9.89785 12.551Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1094_19625"
        x1="9.99684"
        y1="3.7551"
        x2="9.99684"
        y2="16.2449"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC001" />
        <stop offset="1" stopColor="#FF4901" />
      </linearGradient>
    </defs>
  </svg>
);

export default DiamondIcon;
